(function () {
  "use strict";

  if (window.__newsletterSectionAssets) return;
  window.__newsletterSectionAssets = true;

  function cleanupContactHash() {
    if (window.location.href.indexOf("contact_posted") === -1) return;
    var hashTarget = document.querySelector('[id^="newsletter-contact-form-"]');
    if (!hashTarget) return;
    if (window.history && typeof window.history.replaceState === "function") {
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.search + "#" + hashTarget.id,
      );
    }
  }

  function init(scope) {
    cleanupContactHash();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (ev) {
    var target = ev.target;
    if (
      !target || !target.classList ||
      !target.classList.contains("newsletter-section")
    ) return;
    init(target);
  });
})();
